import styled, { keyframes } from "styled-components";
import { FaInfoCircle } from "react-icons/fa";
import { Skeleton } from "antd";

var shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

export const InfoIcon = styled(FaInfoCircle)`
  position: absolute;
  bottom: 8px;
  left: 8px;
  color: #999;
  cursor: help;
  font-size: 14px;
  opacity: 0.7;
  
  &:hover {
    opacity: 1;
  }
`;

export const Card = styled.div`
  background-color: #f9f9f9;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 12px;
  min-width: 300px; /* Match column minWidth */
  width: 300px; /* Fixed width to align with columns */
  flex: 0 0 300px; /* Fixed width to align with columns */
  text-align: left;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
  cursor: ${({ clickable }) => clickable ? 'pointer' : 'default'};

  ${({ clickable }) => clickable && `
    &:hover {
      background-color: #f0f0f0;
      border-color: #d0d0d0;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
  `}

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    right: -12px;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 12px solid transparent;
    border-bottom: 12px solid transparent;
    border-left: 12px solid #e0e0e0;
    z-index: 1;
  }

  &:last-child::after {
    display: none;
  }
`;

export const Title = styled.h4`
  font-size: 12px;
  color: ${({ color }) => color || "#333"};
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  position: absolute;
  top: 8px;
  left: 8px;
`;

export const Value = styled.div`
  font-size: 24px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-top: 16px;
`;

export const Percentage = styled.div`
  position: absolute;
  top: 6px;
  right: 6px;
  background-color: #f1f1f1;
  color: #999;
  font-size: 9px;
  font-weight: normal;
  padding: 1px 4px;
  border-radius: 3px;
  box-shadow: none;
  opacity: 0.85;
`;

export const Details = styled.div`
  position: absolute;
  right: 8px;
  bottom: 8px;
  font-size: 10px;
  color: #666;
  display: flex;
  align-items: center;
`;

export const DetailItem = styled.div`
  display: flex;
  align-items: start;
  color: ${({ color }) => color || "#333"};
  gap: 4px;
  margin-top: -10px;
`;

export const Container = styled.div`
  display: flex;
  padding: 16px;
  gap: 10px; /* Match column gap */
  margin: -16px;
  margin-top: 0;
  margin-bottom: 15px;
  /* Remove overflow-x and scrollbar styles since scrolling is handled by parent */
  min-width: max-content; /* Ensure content doesn't wrap */
`;

export const SkeletonCard = styled(Card)`
  background: linear-gradient(90deg, #f5f5f5 25%, #e8e8e8 50%, #f5f5f5 75%);
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
  padding: 16px;

  &::after {
    border-left-color: #e8e8e8;
  }
`;

export var ShimmerBox = styled.div`
  width: ${function(props) { return props.width || '100%'; }};
  height: ${function(props) { return props.height || '20px'; }};
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
`;